import {
	Component
} from '@angular/core';

import { BaseReportKpiComponent } from 'rev-shared/ui/reports/BaseReportKpi.Component';

@Component({
	selector: 'video-report-kpis',
	templateUrl: './VideoReportKpis.Component.html',
	standalone: false
})
export class VideoReportKpisComponent extends BaseReportKpiComponent {
}
